// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__PmY_S","content":"GlobalSearch_content__3YGDr"};